import React from "react";
import { TablePagination } from "@material-ui/core";

export interface PaginationMetadata {
  next?: unknown;
  prev?: unknown;
  direction?: "before" | "after";
  page_items?: number;
  total_count?: number;
}

export interface PaginationState {
  pageLimit: number;
  pageBefore?: unknown;
  pageAfter?: unknown;
  currentPage: number;
}

interface SearchPaginationProps {
  pagination?: PaginationMetadata;
  pageLimit: number;
  currentPage: number;
  onPageChange: (update: Omit<PaginationState, "pageLimit">) => void;
  onPageLimitChange?: (newPageLimit: number) => void;
  rowsPerPageOptions?: number[];
}

const SearchPagination: React.VFC<SearchPaginationProps> = ({
  pagination,
  pageLimit,
  currentPage,
  onPageChange,
  onPageLimitChange,
  rowsPerPageOptions = [10, 25, 50, 100],
}) => {
  if (!pagination) return null;

  const totalCount = pagination.total_count || 0;

  const handleChangePage = (_event: unknown, newPage: number) => {
    if (newPage > currentPage) {
      // Go to next page (older items in descending order)
      onPageChange({ pageBefore: pagination.next, pageAfter: undefined, currentPage: newPage });
    } else if (newPage < currentPage) {
      // Go to previous page (newer items in descending order)
      onPageChange({ pageBefore: undefined, pageAfter: pagination.prev, currentPage: newPage });
    }
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newPageLimit = parseInt(event.target.value, 10);
    if (onPageLimitChange) {
      onPageLimitChange(newPageLimit);
      // Reset to first page when changing page size
      onPageChange({ pageBefore: undefined, pageAfter: undefined, currentPage: 0 });
    }
  };

  return (
    <TablePagination
      component="div"
      count={totalCount}
      page={currentPage}
      onPageChange={handleChangePage}
      rowsPerPage={pageLimit}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
    />
  );
};

export default SearchPagination;
